/**
 *  导出excel文件
 *  @module downloadExcel
 *  @param { string } name - 文件名
 *  @param { blob } data - 二进制数据
 *  @param { src } [src=null] - 文件url
 */
export default function downloadExcel(name, data, src = null) {
  const fileName = name
  if (data) {
    const blob = new Blob([data], {
      type: 'application/vnd.ms-excel' + ';charset=utf-8',
    })
    src = window.URL.createObjectURL(blob)
  }

  if (src) {
    const a = document.createElement('a')
    const event = new MouseEvent('click')
    a.download = fileName
    a.href = src
    a.target = '_blank'
    a.dispatchEvent(event)
  }
}
